<div class="animated fadeInRight">
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    modulo="Promociones" [tituloCard]="idPromo + ' Bonificadores (venta)'" titulo="Promociones">
  </app-lfsa-card-v2>
</div>

<ng-template #innTemplateButton>
  <div class="col-md-6 text-end mb-2">
    <div *ngIf="!verFormularioAgregarBonificador">
      <button class="btn btn-outline-danger me-2" routerLink="..">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button class="btn btn-outline-success" (click)="nuevoBonificador()">
        <i aria-hidden="true" class="fa fa-plus"></i>
        Nuevo Bonificador
      </button>
    </div>
  </div>
</ng-template>

<ng-template #enviarTemplateEdit>
  <div *ngIf="!verFormularioAgregarBonificador">
    <div class="mb-3">
      <button class="btn btn-success" (click)="downloadCsv()"><i class="fas fa-file-csv me-1"></i>Descargar</button>
      <button class="btn btn-danger" (click)="eliminarTodo()">Eliminar todo</button>
    </div>
    <ag-grid-angular #agGridBonificadores (gridReady)="onGridReady($event)" class="ag-theme-alpine"
      [columnDefs]="columnDefsBonificadores" [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
      id="myGridListGaritas" [ngStyle]="{width: '100%', height: '400px'}" [paginationPageSize]="15"
      [pagination]="true" [rowData]="rowDataBonificadores">
    </ag-grid-angular>
  </div>
  <app-promo-bono-form
    [bonificador]="bonificador"
    [idPromo]="idPromo"
    [tipoPromo]="tipoPromo"
    [material]="material"
    [grupos]="grupos"
    (back)="back()"
    (create)="guardarBonificador($event)"
    *ngIf="verFormularioAgregarBonificador"></app-promo-bono-form>
</ng-template>
<ng-container *ngIf="verFormularioAgregarBonificador || mostrarModalVariantes">
  <app-material-modal (onSelect)="materialSelected($event)"></app-material-modal>
</ng-container>

<!-- Modal Variantes (Combos tipo 10) -->
<app-modal-variantes
  *ngIf="mostrarModalVariantes"
  [open]="mostrarModalVariantes"
  [idPromo]="idPromo"
  [bonificador]="bonificadorParaVariante"
  (close)="cerrarModalVariantes()">
</app-modal-variantes>
